import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import app from './modules/app';
import valuationData from './modules/valuationData';
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    app: app,
    valuationData: valuationData
  },
  getters: getters
});
export default store;